export default __webpack_public_path__ + "static/media/In transit.935c2e80.svg";